import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs/operators';
import { ClientPageSectionModel } from '../../domain/models/dynamic-form-schema.model';
import { SelectionService } from './selection.service';

@Injectable({
    providedIn: 'root'
})
export class DynamicFormOptionsService {
    constructor(private readonly selectionService: SelectionService) {}

    enrichSectionsWithOptions(
        sections: ClientPageSectionModel[]
    ): ClientPageSectionModel[] {
        sections.forEach((section) => {
            section.rows.forEach((row) => {
                row.fields.forEach((field) => {
                    const supportsOptions = [
                        'select',
                        'single-select',
                        'multi-select'
                    ].includes(field.type);
                    const optionsSource = field.optionsSource ?? field.key;

                    if (!supportsOptions || !optionsSource) {
                        return;
                    }

                    field.options$ = this.selectionService
                        .getSelectionsByOptionsKey(optionsSource)
                        .pipe(shareReplay(1));
                });
            });
        });
        return sections;
    }
}
